import { Debounce, mergeObject, Module, Second } from '@nu-art/ts-common';
import { ModuleFE_EMInterface } from '../../_entity/runtime/em-interface/ModuleFE_EMInterface.js';
import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend';
const dispatch_OnPractitionerConfigUpdated = new ThunderDispatcher('__onPractitionerConfigUpdated');
class ModuleFE_AdvisorState_Class extends Module {
    practitionerConfig;
    debounce_UpdateConfig = new Debounce(() => this.updatePractitionerConfig_Impl(), 1 * Second, 5 * Second);
    constructor() {
        super();
        this.practitionerConfig = this.getDefaultPractitionerConfig();
    }
    //######################### Internal Logic #########################
    getDefaultPractitionerConfig = () => {
        return {
            collapsing: {
                homePanel: {
                    hpi: true,
                    cc: true,
                    history: true,
                    ddx: undefined,
                }
            },
            featureFlag: {
                magicWand: false,
            }
        };
    };
    updatePractitionerConfig_Impl = async () => {
        const uiState = this.practitionerConfig;
        if (!uiState)
            return;
        try {
            await ModuleFE_EMInterface.vv1.advisorUtils.setPractitionerConfig({ uiState }).executeSync();
            this.logDebug('Updated UI state');
        }
        catch (err) {
            this.logError('Failed to update UI state', err);
        }
    };
    //######################### Interface #########################
    setProperties = (config) => {
        if (!config)
            return;
        this.practitionerConfig = mergeObject(this.practitionerConfig, config);
        if (!ModuleFE_EMInterface.isAvatarMode())
            this.debounce_UpdateConfig.trigger();
        dispatch_OnPractitionerConfigUpdated.dispatchUI();
    };
    setProperty = {
        collapsing: {
            homePanel: {
                hpi: (value) => this.setProperties({ collapsing: { homePanel: { hpi: value } } }),
                cc: (value) => this.setProperties({ collapsing: { homePanel: { cc: value } } }),
                history: (value) => this.setProperties({ collapsing: { homePanel: { history: value } } }),
                ddx: (value) => this.setProperties({ collapsing: { homePanel: { ddx: value } } }),
            }
        },
        featureFlag: {
            magicWand: (value) => this.setProperties({ featureFlag: { magicWand: value } }),
        }
    };
    getStateProperty = {
        collapsing: {
            homePanel: {
                hpi: () => this.practitionerConfig?.collapsing?.homePanel?.hpi,
                cc: () => this.practitionerConfig?.collapsing?.homePanel?.cc,
                history: () => this.practitionerConfig?.collapsing?.homePanel?.history,
                ddx: () => this.practitionerConfig?.collapsing?.homePanel?.ddx,
            }
        },
        featureFlag: {
            magicWand: () => this.practitionerConfig?.featureFlag?.magicWand,
        }
    };
}
export const ModuleFE_AdvisorState = new ModuleFE_AdvisorState_Class();
//# sourceMappingURL=ModuleFE_AdvisorState.js.map